import { all, call, put, takeLatest } from 'redux-saga/effects';
import qs from 'qs';
import envConfig from '../../config';
import {
  fetchCalendarEvents,
  loadMoreCalendarEventsByEntity,
  updateCalendarEventByLinkEntities,
} from '../routines/calendarRoutines';
import { request } from '../../common/util/RestClient';
import { convertFilterToVfl } from '../../common/util/velarisFilterLanguageUtils';
import {
  CALENDAR_EVENT_DEFAULT_PAGE,
  CALENDAR_EVENT_DEFAULT_PAGE_SIZE,
} from '../../common/constants/CalendarEventConstants';

export function getFetchEntityByIdHelper(payload = {}) {
  const { page, pageSize, query, filters, level, entityId } = payload || {};
  const params = {
    page: page || CALENDAR_EVENT_DEFAULT_PAGE,
    pageSize: pageSize || CALENDAR_EVENT_DEFAULT_PAGE_SIZE,
    level,
    entity: entityId,
  };
  if (filters && filters.length > 0) {
    params.filters = convertFilterToVfl(filters);
  }

  if (query && query.length > 0) {
    params.query = query;
  }

  const url = `${envConfig.APIG_URL}calendar/event?${qs.stringify(params)}`;
  return request(url);
}

export function* fetchCalendarEventSaga({ payload }) {
  const { level, entityId, filters, query, page, pageSize } = payload;
  try {
    const convertedFilters = convertFilterToVfl(filters);
    const params = {};
    if (convertedFilters) params.filters = convertedFilters;
    if (query) params.query = query;
    if (page) params.page = page;
    if (pageSize) params.pageSize = pageSize;

    let URL = `${envConfig.APIG_URL}calendar/event?level=${level}&entity=${entityId}`;
    if (Object.keys(params).length > 0) {
      URL = `${URL}&${qs.stringify(params)}`;
    }
    const response = yield call(request, URL);

    yield put(fetchCalendarEvents.success(response));
  } catch (error) {
    yield put(fetchCalendarEvents.failure({ error }));
  }
}

function* updateCalendarEventByLinkEntitiesSaga({ payload }) {
  const { formData, eventId } = payload;

  try {
    const URL = `${envConfig.APIG_URL}calendar/events/${eventId}/linking`;
    const config = {
      method: 'PATCH',
      payload: formData,
    };
    const response = yield call(request, URL, config);
    yield put(updateCalendarEventByLinkEntities.success(response));
  } catch (err) {
    yield put(updateCalendarEventByLinkEntities.failure({ error: err }));
  }
}

export function* loadMoreCalendarEventsByEntitySaga({ payload }) {
  try {
    const response = yield call(getFetchEntityByIdHelper, payload);
    yield put(loadMoreCalendarEventsByEntity.success(response));
  } catch (error) {
    yield put(loadMoreCalendarEventsByEntity.failure({ error }));
  } finally {
    yield put(loadMoreCalendarEventsByEntity.fulfill());
  }
}
export default function* root() {
  yield all([takeLatest(fetchCalendarEvents, fetchCalendarEventSaga)]);
  yield all([
    takeLatest(
      updateCalendarEventByLinkEntities.TRIGGER,
      updateCalendarEventByLinkEntitiesSaga
    ),
  ]);
  yield all([
    takeLatest(
      loadMoreCalendarEventsByEntity.TRIGGER,
      loadMoreCalendarEventsByEntitySaga
    ),
  ]);
}
